import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import DataTable, { DATA_TABLE_TYPES } from "../../components/Table/DataTable";
import ReportsService from "../../services/reports.service";
import { DATA_TABLE_FILTER } from "../../components/Table/FilterPopup";
import { ByteDisplay } from "../../components/General/ByteDisplay";
import { TimeDisplay } from "../../components/General/TimeDisplay";
import ChannelsService from "../../services/channels.service";
import { DataLoading } from "../../components/PreLoader/PreLoader";
import moment from "jalali-moment";

const Stats = ({}) => {
    const {t} = useTranslation();
    const {setPageTitle} = useOutletContext();
    const [channels, setChannels] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        ChannelsService.listAsOptions().then((data) => {
            setChannels(data);
            setIsLoading(false);
        })
    }, [])

    let defaultFilterConfig = {
        date: {
            type: "range",
            from: moment().subtract(10, 'days').format('YYYY-MM-DD'),
            to: moment().format('YYYY-MM-DD'),
        }
    };
    
    const columns = [
        { 
            key: "id",
            label: "#"
        },
        { 
            key: "date", 
            label: t("Date"), 
            filter: DATA_TABLE_FILTER.REPORT_DATE,
            forceFilter: true,
            type: DATA_TABLE_TYPES.REPORT_DATE,
            sort: true
        },
        { 
            key: "total_bytes", 
            label: t("Downloaded Bytes"), 
            render: (row) => (<ByteDisplay bytes={row.total_bytes} />),
            sort: true
        },
        { 
            key: "total_downloaded_seconds", 
            label: t("Downloaded"),
            render: (row) => (<TimeDisplay seconds={row.total_downloaded_seconds} />),
            sort: true
        },
        { 
            key: "total_watched_bytes", 
            label: t("Watched Bytes"),
            render: (row) => (<ByteDisplay bytes={row.total_watched_bytes} />),
            sort: true
        },
        { 
            key: "total_watched_seconds", 
            label: t("Watched"),
            render: (row) => (<TimeDisplay seconds={row.total_watched_seconds} />),
            sort: true
        }
        
    ]
    useEffect(() => { 
        setPageTitle(t("Yearly and monthly overview"));
    }, [setPageTitle]);
    return (
        <>
            {isLoading?(
                <DataLoading small={true} />
            ):(
                <DataTable 
                    columns={columns} 
                    fetcher={ReportsService.stats}
                    searchPlaceholder={t("Search by Account Number or Customer Name or E-Mail...")}
                    defaultPageSize={31}
                    defaultSortKey={"date"}
                    customFilters={[{
                        key: "uid", 
                        label: t("Account Number"), 
                        filter: DATA_TABLE_FILTER.INPUT,
                    },{
                        key: "ip", 
                        label: t("IP Address"), 
                        filter: DATA_TABLE_FILTER.INPUT,
                    }, { 
                        key: "channel_id", 
                        label: t("Channel"),
                        filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
                        options: channels
                    }, { 
                        key: "quality", 
                        label: t("Quality"),
                        filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
                        options: [
                            { key: "1080", value: "1080" }, 
                            { key: "720", value: "720" }, 
                            { key: "480", value: "480" },
                            { key: "360", value: "360" },
                            { key: "288", value: "288" },
                            { key: "180", value: "180" }
                        ]
                    }]}
                    defaultFilterConfig={defaultFilterConfig}
                />
            )}
            
        </>
    )
}
export default Stats;